import type { SVGProps } from "react";

/* Ícones próprios dos módulos da menubar — traço monocromático (currentColor), 24×24. */

type P = SVGProps<SVGSVGElement>;

function Base({ children, ...p }: P) {
  return (
    <svg viewBox="0 0 24 24" width={22} height={22} fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden {...p}>
      {children}
    </svg>
  );
}

/** Operação: caminhão sobre a rota, com marcador de destino. */
export function IconOperacao(p: P) {
  return (
    <Base {...p}>
      <path d="M2.5 13.5V7.5a1 1 0 0 1 1-1h8.5v7" />
      <path d="M12 9h3.6l2.9 3v1.5" />
      <circle cx="6.5" cy="14.5" r="1.6" />
      <circle cx="15.5" cy="14.5" r="1.6" />
      <path d="M8.1 14.5h5.8M2.5 13.5v1h2.4M17.1 14.5h1.4v-1" />
      <path d="M3 20.5h4.5c1.5 0 1.5-2 3-2h4c1.5 0 1.5 2 3 2H21" strokeDasharray="0.1 2.6" strokeWidth={1.9} />
      <path d="M20 3.2c-1.2 0-2 .9-2 2 0 1.5 2 3.3 2 3.3s2-1.8 2-3.3c0-1.1-.8-2-2-2Z" />
    </Base>
  );
}

/** Documentos: folha com dobra, linhas e chave de acesso (código de barras). */
export function IconDocumentos(p: P) {
  return (
    <Base {...p}>
      <path d="M14 2.5H6.5a1.5 1.5 0 0 0-1.5 1.5v16a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5V7.5Z" />
      <path d="M14 2.5V7.5h5" />
      <path d="M8 10.5h5M8 13h8" />
      <path d="M8 16.2v2.6M9.6 16.2v2.6M10.6 16.2v2.6M12.4 16.2v2.6M13.4 16.2v2.6M15.2 16.2v2.6M16 16.2v2.6" strokeWidth={1.1} />
    </Base>
  );
}

/** Financeiro: cédula com cifrão e moedas empilhadas. */
export function IconFinanceiro(p: P) {
  return (
    <Base {...p}>
      <rect x="2.5" y="5.5" width="14" height="9" rx="1.5" />
      <path d="M9.5 7.8v4.4M11 8.6c-.3-.5-.9-.8-1.6-.8-.9 0-1.6.5-1.6 1.2 0 1.6 3.3.9 3.3 2.4 0 .7-.7 1.2-1.6 1.2-.7 0-1.4-.3-1.7-.9" strokeWidth={1.3} />
      <path d="M4.5 8v0M14.5 12v0" strokeWidth={2} />
      <ellipse cx="17.5" cy="16.5" rx="4" ry="1.5" />
      <path d="M13.5 16.5v2c0 .8 1.8 1.5 4 1.5s4-.7 4-1.5v-2" />
    </Base>
  );
}

/** Cadastros: fichário com cartão de identificação (pessoa + linhas). */
export function IconCadastros(p: P) {
  return (
    <Base {...p}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M8 5V3.5M16 5V3.5" />
      <circle cx="8.5" cy="11" r="2" />
      <path d="M5.5 16.2c.4-1.5 1.6-2.4 3-2.4s2.6.9 3 2.4" />
      <path d="M14 10h4M14 12.8h4M14 15.6h2.5" />
    </Base>
  );
}

/** Sistema: painel/monitor com engrenagem. */
export function IconSistema(p: P) {
  return (
    <Base {...p}>
      <path d="M11 17.5H4.5a1.5 1.5 0 0 1-1.5-1.5V5a1.5 1.5 0 0 1 1.5-1.5h14A1.5 1.5 0 0 1 20 5v5" />
      <path d="M8 21h4M10 17.5V21" />
      <circle cx="17.5" cy="16.5" r="1.7" />
      <path d="M17.5 12.3v1.4M17.5 19.3v1.4M21.7 16.5h-1.4M14.7 16.5h-1.4M20.5 13.5l-1 1M15.5 18.5l-1 1M20.5 19.5l-1-1M15.5 14.5l-1-1" />
    </Base>
  );
}

export const MENU_ICONS = {
  operacao: IconOperacao,
  documentos: IconDocumentos,
  financeiro: IconFinanceiro,
  cadastros: IconCadastros,
  sistema: IconSistema,
} as const;
